var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgUpload(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19 16V17C19 18.2281 18.2281 19 17 19H7C5.77193 19 5 18.2281 5 17V16C5 15.4561 4.54386 15 4 15C3.45614 15 3 15.4561 3 16V17C3 19.2105 4.78947 21 7 21H17C19.2105 21 21 19.2105 21 17V16C21 15.4561 20.5439 15 20 15C19.4561 15 19 15.4561 19 16ZM11.2982 3.29825L7.29825 7.29824C7.10526 7.47368 7 7.7193 7 8C7 8.54386 7.45614 9 8 9C8.2807 9 8.52632 8.89474 8.70175 8.70175L12.7018 4.70175C12.8947 4.52632 13 4.2807 13 4C13 3.45614 12.5439 3 12 3C11.7193 3 11.4737 3.10526 11.2982 3.29825ZM16.7018 7.29824L12.7018 3.29825C12.5263 3.10526 12.2807 3 12 3C11.4561 3 11 3.45614 11 4C11 4.2807 11.1053 4.52632 11.2982 4.70175L15.2982 8.70175C15.4737 8.89474 15.7193 9 16 9C16.5439 9 17 8.54386 17 8C17 7.7193 16.8947 7.47368 16.7018 7.29824ZM13 16V4C13 3.45614 12.5439 3 12 3C11.4561 3 11 3.45614 11 4V16C11 16.5439 11.4561 17 12 17C12.5439 17 13 16.5439 13 16Z",
    fill: "currentColor"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgUpload);
export default __webpack_public_path__ + "static/media/upload.2fd032aa.svg";
export { ForwardRef as ReactComponent };